export default __webpack_public_path__ + "static/media/aplss.51fae8c6.png";